import { Container } from 'unstated';

export interface AvisoDivergenciaFusoHorarioState {
  ativo: boolean;
  tipo: 'fuso' | 'horario';
  contexto: 'online' | 'offline';
  valorDispositivo: string;
  valorEmpresa: string;
}

export class AvisoDivergenciaFusoHorarioContainer extends Container<AvisoDivergenciaFusoHorarioState> {
  state: AvisoDivergenciaFusoHorarioState = {
    ativo: false,
    tipo: 'fuso',
    contexto: 'online',
    valorDispositivo: '',
    valorEmpresa: ''
  };

  ativar = (
    tipo: 'fuso' | 'horario',
    contexto: 'online' | 'offline',
    valorDispositivo: string,
    valorEmpresa: string
  ) => {
    this.setState({
      ativo: true,
      tipo,
      contexto,
      valorDispositivo,
      valorEmpresa
    });
  };

  desativar = () => {
    this.setState({ ativo: false });
  };
}

export default new AvisoDivergenciaFusoHorarioContainer();
